import { get } from "lodash-es";
import { derived, writable } from "svelte/store";
import translations from "../data/translations";

export const locale = writable("en");
export const locales = Object.keys(translations);

export type Variables = {
  [key: string]: string;
};

export type Locale = {
  [key: string]: string;
};

export function translate(code: string, key: string, vars: Variables | null) {
  // Grab the translation from the translations object.
  let text = get(translations[code], key);

  if (text == null) {
    return key;
  }

  if (typeof text != "string") {
    throw new Error("Key path did not return a string: " + key);
  }

  // Replace any passed in variables in the translation string.
  if (vars) {
    Object.keys(vars).map((k) => {
      const regex = new RegExp(`{{${k}}}`, "g");

      text = (text as string).replace(regex, vars[k]);
    });
  }

  return text;
}

export const t = derived(
  locale,
  ($locale) =>
    (key: string, vars = {}) =>
      translate($locale, key, vars)
);
